import { IGame } from "../Interfaces";

const garden: IGame = {
  "name": "Garden",
  "author": "Yihao",
  "time": new Date("2020-08-14T05:42:27.321Z"),
  "description": "This game resembles the life and death of plants in a garden. Surviving cells are green or pink, representing leaves and flowers. Starving cells are yellow, and over-populated cells are purple, representing dead leaves and fruits. Dead cells are brown, representing soil.",
  "refreshFrequency": 3,
  "width": 15,
  "height": 15,
  "seeds": [
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      false,
      false
    ],
    [
      false,
      true,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      true,
      false
    ],
    [
      false,
      true,
      true,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      true,
      true,
      true,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      false,
      false
    ],
    [
      false,
      false,
      true,
      true,
      true,
      false,
      true,
      false,
      true,
      false,
      true,
      true,
      true,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      true,
      true,
      true,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      true,
      true,
      true,
      false
    ],
    [
      false,
      true,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      false,
      true,
      false
    ],
    [
      false,
      false,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  ],
  "surviveRangeLower": 2,
  "surviveRangeUpper": 3,
  "reproductionRangeLower": 3,
  "reproductionRangeUpper": 3,
  "borderPolicy": "alive",
  "styles": [
    [
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#2b2624",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#3b3432",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#cffa88",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 0,
        "color": "#eee",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      }
    ],
    [
      {
        "size": 30,
        "color": "#c29969",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 60,
        "color": "#f8de79",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 90,
        "color": "green",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 90,
        "color": "#f0b2d0",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 80,
        "color": "#aa3f74",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 70,
        "color": "#933965",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 60,
        "color": "#772d51",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 50,
        "color": "#692949",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 40,
        "color": "#4d1d35",
        "backgroundColor": "#433b36",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      }
    ]
  ]
};

export default garden;